import React from 'react';
import { Formik, Form, Field } from 'formik';
import Radio from '@tds/core-radio';
import { getStepOneSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { channelFields } from '../utils/index';
import { useFormikScrollToError } from '../utils/utils';

const StepOne = ({
  onSubmit,
  stepData: {
    legalBusinessName,
    firstName,
    lastName,
    email,
    mobileNumber,
    // bestTimeofDayToContact,
    prefferedLanguage,
    province,
    existingTelusAccount,
    businessAccountNumber
  },
  role
}) => {
  const translations = useTranslationsContext();
  const {
    REFERRALS: {
      stepOne: { labels, errorLabels }
    }
  } = translations;
  // const [morning, afternoon, evening] = labels.timeOfDayOptions;
  const [english, french] = labels.preferredLanguageOptions;
  const [
    BC,
    AB,
    SK,
    MB,
    ON,
    QC,
    ATL,
    NB,
    NS,
    PEI,
    NFL
  ] = labels.provinceOptions;
  const [yes, no] = labels.existingTelusAccountOptions;
  const pageKey = 'customerInformation';
  return (
    <Formik
      validationSchema={getStepOneSchema(errorLabels, channelFields(pageKey))}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        legalBusinessName: legalBusinessName || '',
        firstName: firstName || '',
        lastName: lastName || '',
        email: email || '',
        mobileNumber: mobileNumber || '',
        // bestTimeofDayToContact: bestTimeofDayToContact || '',
        prefferedLanguage: prefferedLanguage || '',
        province: province || '',
        existingTelusAccount: existingTelusAccount || '',
        businessAccountNumber: businessAccountNumber || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, isValidating, isSubmitting }) => (
        <>
          {useFormikScrollToError(isSubmitting, isValidating, errors)}
          <Form>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <span className="select-placeholder">
                {labels.businessLegalName}*
              </span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.legalBusinessName && touched.legalBusinessName
                ? 'error'
                : ''
                }`}
            >
              <Field
                name="legalBusinessName"
                type="text"
                className="select-style"
                placeholder={labels.businessLegalName}
              />
              <>
                <div className="error_messages">
                  <span className="frg-body-font-14px">
                    {errors.legalBusinessName}
                  </span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <span className="select-placeholder">{labels.firstName}*</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.firstName && touched.firstName ? 'error' : ''
                }`}
            >
              <Field
                name="firstName"
                type="text"
                className="select-style"
                placeholder={labels.firstName}
              />
              <>
                <div className="error_messages">
                  <span className="frg-body-font-14px">{errors.firstName}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <span className="select-placeholder">{labels.lastName}*</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.lastName && touched.lastName ? 'error' : ''
                }`}
            >
              <Field
                name="lastName"
                type="text"
                className="select-style"
                placeholder={labels.lastName}
              />
              <>
                <div className="error_messages">
                  <span className="frg-body-font-14px">{errors.lastName}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <span className="select-placeholder">{labels.email}*</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.email && touched.email ? 'error' : ''
                }`}
            >
              <Field
                name="email"
                type="text"
                className="select-style"
                placeholder={labels.email}
              />
              <>
                <div className="error_messages">
                  <span className="frg-body-font-14px">{errors.email}</span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            <div className="main-content-form-headers" style={{ marginTop: 20 }}>
              <span className="select-placeholder">{labels.mobileNumber}*</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.mobileNumber && touched.mobileNumber ? 'error' : ''
                }`}
            >
              <Field
                name="mobileNumber"
                type="text"
                className="select-style"
                placeholder={labels.mobileNumber}
              />
              <>
                <div className="error_messages">
                  <span className="frg-body-font-14px">
                    {errors.mobileNumber}
                  </span>
                </div>
                <div id="username_error_icon" className="error_messages_icon">
                  <img src={ErrorIcon} alt="error_icon" />
                </div>
              </>
            </div>
            {/* <div className="main-content-form-headers" style={{ marginTop: 20 }}>
            <span className="select-placeholder">{labels.bestTimeOfDay}</span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${
              errors.bestTimeofDayToContact && touched.bestTimeofDayToContact
                ? 'error'
                : ''
            }`}
          >
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                as={Radio}
                type="radio"
                value="morning"
                className="select-style"
              />{' '}
              {morning}
            </label>
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                type="radio"
                as={Radio}
                value="afternoon"
                className="select-style"
              />{' '}
              {afternoon}
            </label>
            <label style={{ display: 'flex' }}>
              <Field
                name="bestTimeofDayToContact"
                type="radio"
                as={Radio}
                value="evening"
                className="select-style"
              />{' '}
              {evening}
            </label>
            <label>
              <div>
                <span className="frg-body-font-16px warning-error-message">
                  {errors.bestTimeofDayToContact}
                </span>
              </div>
            </label>
          </div> */}
            <div className="main-content-form-headers" style={{ marginTop: 10 }}>
              <span className="select-placeholder">
                {labels.prefferedLanguage}*
              </span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.prefferedLanguage && touched.prefferedLanguage
                ? 'error'
                : ''
                }`}
            >
              <label style={{ display: 'flex' }}>
                <Field
                  name="prefferedLanguage"
                  type="radio"
                  as={Radio}
                  value="english"
                  className="select-style"
                />{' '}
                {english}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="prefferedLanguage"
                  type="radio"
                  as={Radio}
                  value="french"
                  className="select-style"
                />{' '}
                {french}
              </label>
              <label>
                <div>
                  <span className="frg-body-font-16px warning-error-message">
                    {errors.prefferedLanguage}
                  </span>
                </div>
              </label>
            </div>
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.province}*</span>
            </div>
            <div
              style={{ position: 'relative' }}
              className={`input-container ${errors.province && touched.province ? 'error' : ''
                }`}
            >
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={BC}
                  className="select-style"
                />{' '}
                {BC}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={AB}
                  className="select-style"
                />{' '}
                {AB}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={SK}
                  className="select-style"
                />{' '}
                {SK}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={MB}
                  className="select-style"
                />{' '}
                {MB}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={ON}
                  className="select-style"
                />{' '}
                {ON}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={QC}
                  className="select-style"
                />{' '}
                {QC}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={ATL}
                  className="select-style"
                />{' '}
                {ATL}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={NB}
                  className="select-style"
                />{' '}
                {NB}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={NS}
                  className="select-style"
                />{' '}
                {NS}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={PEI}
                  className="select-style"
                />{' '}
                {PEI}
              </label>
              <label style={{ display: 'flex' }}>
                <Field
                  name="province"
                  as={Radio}
                  type="radio"
                  value={NFL}
                  className="select-style"
                />{' '}
                {NFL}
              </label>
              <label>
                <div>
                  <span className="frg-body-font-16px warning-error-message">
                    {errors.province}
                  </span>
                </div>
              </label>
            </div>
            {channelFields(pageKey) && (
              <>
                <div
                  className="main-content-form-headers"
                  style={{ marginTop: 10 }}
                >
                  <span className="select-placeholder">
                    {labels.existingTelusAccount}
                  </span>
                </div>
                <div
                  style={{ position: 'relative' }}
                  className={`input-container ${errors.existingTelusAccount && touched.existingTelusAccount
                    ? 'error'
                    : ''
                    }`}
                >
                  <label style={{ display: 'flex' }}>
                    <Field
                      name="existingTelusAccount"
                      type="radio"
                      as={Radio}
                      value="Yes"
                      className="select-style"
                    />{' '}
                    {yes}
                  </label>
                  <label style={{ display: 'flex' }}>
                    <Field
                      name="existingTelusAccount"
                      type="radio"
                      as={Radio}
                      value="No"
                      className="select-style"
                    />{' '}
                    {no}
                  </label>
                  <label>
                    <div>
                      <span className="frg-body-font-16px warning-error-message">
                        {errors.existingTelusAccount}
                      </span>
                    </div>
                  </label>
                </div>
              </>
            )}
            {values.existingTelusAccount === yes && (
              <>
                <div className="main-content-form-headers">
                  <span className="select-placeholder">
                    {`${labels.businessAccountNumber} (if known)`}
                  </span>
                </div>
                <div
                  style={{ position: 'relative' }}
                  className={`input-container ${errors.businessAccountNumber && touched.businessAccountNumber
                    ? 'error'
                    : ''
                    }`}
                >
                  <Field
                    name="businessAccountNumber"
                    type="text"
                    className="select-style"
                    placeholder={labels.businessAccountNumber}
                  />
                  <>
                    <div className="error_messages">
                      <span className="frg-body-font-16px warning-error-message">
                        {errors.businessAccountNumber}
                      </span>
                    </div>
                    <div id="username_error_icon" className="error_messages_icon">
                      <img src={ErrorIcon} alt="error_icon" />
                    </div>
                  </>
                </div>
              </>
            )}
            <button style={{marginBottom:"20px"}} className="frg-button color-green" type="submit">
              Next
            </button>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default StepOne;
